import React from 'react';
import styles from './CompleteProfile.module.css';
import { t } from 'i18next';

function CompleteProfile({ color = '#0464B2', progress = 0, darkTheme, ...props }) {
    return (
        <div className={styles.container} {...props} style={{
            backgroundColor: darkTheme ? "#0464B2" : ""
        }}>
            <div className={styles.textContainer}>
                <h2 className={styles.heading} style={{color:darkTheme?'white':"black"}}>{t('completeProfile.heading')}</h2>
                <p className={styles.subText} style={{color:darkTheme?'white':"black"}}>
                    {t('completeProfile.subText').split('90%').map((part, index) => (
                        <>
                            {part}
                            {index === 0 && <span className={styles.highlight}>90%</span>}
                        </>
                    ))}
                </p>
            </div>
            <div className={styles.progressContainer}>
                <div
                    className={styles.circleProgress}
                    style={{ '--progress': progress, '--progressColor': color }}
                >
                    <div className={styles.innerCircle}></div>
                    <span className={styles.progressText}>{progress}%</span>
                </div>
            </div>
        </div>
    );
}

export default CompleteProfile;
